import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { ExtendedRoute } from '@hdms/shared/common-types';

enum Extensions {
  HTML = '.html'
}

/**
 * Checks the given URL segments for the .html extension
 * at the end. Match the segment path with route path provided in
 * route data itself.
 *
 * @param segments The url segments as given by the router.
 * @param group The url segment group as given by the router.
 * @param route The route as given by the router.
 *
 */
export function htmlExtensionRouteMatcher(
  segments: UrlSegment[],
  group: UrlSegmentGroup,
  route: ExtendedRoute
): UrlMatchResult {
  if (segments[0] && segments[0].path.replace(Extensions.HTML, '') === route.data.path) {
    return { consumed: segments };
  }

  return null;
}
